import {
  SET_CURRENT_PURCHASE_CONFIRMATION,
  CLEAR_CURRENT_PURCHASE_CONFIRMATION,
} from 'actions/payway';
const initialState = null;

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_PURCHASE_CONFIRMATION:
      return action.payload;
    case CLEAR_CURRENT_PURCHASE_CONFIRMATION:
      return null;
    default:
      return state;
  }
}
